import { createContext } from 'react';

export interface Methods {
  setExterminate: (props: IContext['exterminate']) => void;
}

export interface IContext extends Methods {
  exterminate: {
    id?: number | null;
  };
  permissions: {
    PERMISSION_EXTERMINATE_CONTRACT: boolean;
    PERMISSION_UPDATE_CONTRACT_MONTHLY_PAYMENT: boolean;
    PERMISSION_CHANGE_CONTRACT_RESPONSIBLE: boolean;
    PERMISSION_TRANSFER_CONTRACT: boolean;
    PERMISSION_DELETE_CONTRACT: boolean;
  };
}

const Context = createContext<IContext>({} as IContext);

export default Context;
